/* LLS — live review ratings on product cards.
   Collection and article cards show live Lipscore ratings, fetched per product on
   page load by snippets/lls-lipscore-cards.liquid. This file keeps the empty
   .static-rating slots visible so that live widget can render into them, and styles
   the rating row: centre-aligned with bold score/count on collection cards,
   left-aligned on article cards. Ratings are always live (no static snapshot). */
(function(){
  /* Card rating styling: centre the review row in the card + bold the score/count */
  var __st=document.createElement('style');
  __st.textContent='.static-rating{justify-content:center !important;align-items:center !important;}.static-rating__text{font-weight:700 !important;}.lls-cta-primary .static-rating,.lls-cta-subtle .static-rating,.lls-cta-body .static-rating{justify-content:flex-start !important;}';
  (document.head||document.documentElement).appendChild(__st);
  function show(root){
    var els=(root||document).querySelectorAll('.static-rating[data-handle]');
    for(var i=0;i<els.length;i++){
      els[i].style.display='flex';
      els[i].style.minHeight='18px';
    }
  }
  show();
  window.__renderStaticRatings=show;
  var observer=new MutationObserver(function(mutations){
    for(var m=0;m<mutations.length;m++){
      var added=mutations[m].addedNodes;
      for(var n=0;n<added.length;n++){
        var node=added[n];
        if(node.nodeType===1){
          if(node.classList&&node.classList.contains('static-rating')){show(node.parentElement);}
          else if(node.querySelectorAll&&node.querySelectorAll('.static-rating[data-handle]').length){show(node);}
        }
      }
    }
  });
  observer.observe(document.body,{childList:true,subtree:true});
})();
